import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BASE_URL } from "../../constants";
import Header from "../Helper/Header";
import NewFooter from "../Helper/NewFooter";
import ContactForm from "../../components/ContactForm/ContactForm";
const Companies = () => {
  return (
    <>
      <Header />
      <Container fluid>
        {/* Heading 1 */}
        <Row className="justify-content-center">
          <Col className="text-center">
            <h1 className="heading1">Helping</h1>
          </Col>
        </Row>

        {/* Heading 2 */}
        <Row className="justify-content-center">
          <Col className="text-center">
            <h2 className="heading2">
              INDUSTRIAL <br />
              Companies
            </h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col className="text-center">
            <h1 className="heading3">Achieve Net Zero</h1>
          </Col>
        </Row>

        {/* First Grid */}
        <div>
          <Row className="justify-content-center align-items-end">
            {" "}
            {/* Add align-items-end here */}
            <Col md={4} className="left-box">
              <p>
                Industrial companies face increasing pressure to reduce
                emissions, optimize operations, and meet sustainability
                goals—all while maintaining profitability. Traditional methods,
                like spreadsheets and manual calculations, are inefficient and
                prone to errors. Dsider transforms the way industries approach
                Net Zero with powerful simulations, predictive analytics, and
                data-driven decision-making.
              </p>
            </Col>
            <Col md={8} className="d-flex align-items-end">
              {" "}
              {/* Add d-flex and align-items-end here */}
              <img
                src={`${BASE_URL}solutions/industrial_companies.png`}
                alt="Climate Tech"
                className="right-image"
              />
            </Col>
          </Row>
        </div>

        {/* Second Grid */}
        <div className="container " style={{ marginTop: "6rem" }}>
          <Row className="d-flex justify-content-center align-items-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/digital_twin_ simulations.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Optimize Operations with Digital Twin Simulations{" "}
              </h3>
              <ul className="innovation-list">
                <li>
                  Create a virtual replica of your operations to test
                  improvements before implementation.
                </li>
                <li>
                  Simulate different scenarios to identify the most efficient
                  and sustainable approach.
                </li>
                <li>
                  Reduce waste, energy consumption, and costs with optimized
                  workflows..
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/carbon_footprint.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Cut Emissions with Carbon Abatement Analysis
              </h3>
              <ul className="innovation-list">
                <li>
                  Comprehensive carbon footprint tracking across all
                  operations..{" "}
                </li>
                <li>
                  Actionable insights to implement low-carbon technologies
                  effectively.
                </li>
                <li>
                  Data-backed strategies to meet sustainability and regulatory
                  targets.
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/cost_benefit_ analysis.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Maximize Profitability with Financial & Risk Analysis
              </h3>
              <ul className="innovation-list">
                <li>
                  Assess the financial impact of emission reduction strategies.
                </li>
                <li>
                  Identify cost-saving opportunities through efficiency
                  improvements.
                </li>
                <li>
                  Manage operational risks related to supply chains,
                  regulations, and energy use.
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/complex_datasets.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Seamless Data Integration for Smarter Decision-Making{" "}
              </h3>
              <ul className="innovation-list">
                <li>
                  Unify multiple data sources for a complete view of your
                  operations.
                </li>
                <li>
                  Use AI-driven insights to make faster, smarter decisions.
                </li>
                <li>
                  Monitor progress in real-time toward sustainability goals...
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>
        </div>

        {/* Action Box */}
        <Row className="justify-content-center">
          <Col
            className="action-box"
            style={{
              display: "grid",
              gridTemplateRows: "auto 1fr",
              alignItems: "start",
              justifyItems: "start",
            }}
          >
            <h4 className="action-heading">
              Achieve your Net Zero <br /> Goals Faster with <br /> Dsider
            </h4>
            <p
              className="action-text"
              style={{ justifySelf: "end", alignSelf: "end" }}
            >
              Dsider empowers industrial companies to transform their
              sustainability strategies, cut emissions, and optimize
              efficiency—all while maintaining profitability. Whether you're in
              manufacturing, energy production, or heavy industry, our platform
              helps you turn Net Zero ambitions into reality.
            </p>
          </Col>
        </Row>
      </Container>
      <ContactForm showFooter={false}/>
      <NewFooter />
    </>
  );
};

export default Companies;
